import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import Link from 'next/link'

import ROUTES from 'config/routes.json'
import legalPages from 'prismic-translates/legal-pages.json'
import content from 'prismic-translates/page-shop.json'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content, legalPages])

type Props = {
  openSweepRules?: () => void
}

export default function ShopTerms(props: Props) {
  const { openSweepRules } = props

  return (
    <p className={`mt-typography-body2 ${classes.description}`}>
      {t('shop_terms_msg_prt1')}{' '}
      <Link href={ROUTES.SWEEPSTAKE_RULES} prefetch={false} onClick={openSweepRules}>
        {t('sweepstakes_rules')}
      </Link>{' '}
      {t('shop_terms_msg_prt2')}{' '}
      <Link href={ROUTES.TERMS} prefetch={false} onClick={openSweepRules}>
        {t('terms_of_use')}
      </Link>{' '}
      {t('shop_terms_msg_prt3')}
    </p>
  )
}
